import React, { memo, useCallback } from 'react'

import { Icon, Add, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func } from 'prop-types'

import { useLocation, useNavigate } from 'Pods/Shared/ContextBasedRouter'
import DesktopOnlyTooltip from 'Pods/Shared/DesktopOnlyTooltip/DesktopOnlyTooltip'
import { iconSizeMedium } from 'Pods/ThreeDStudio/constants'
import { parseGeneratingRunId } from 'Pods/ThreeDStudio/Hooks/generatingRunUrl'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { clearModelSettings } from 'Pods/ThreeDStudio/Store/actions/modelSettings'

// Stays interactive at the concurrency cap: hitting the cap only blocks starting
// another run, not reaching the starting page - which the top navigation reaches
// anyway. The cap messaging lives on the Generate button there instead.
function NewModelCard({ onNavigate }) {
  const t = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  // /ai alone means "composing a new generation", but /ai?run=<id> means the user is
  // watching that run's card - the pathname is still /ai, so without the parameter check
  // this card and the generating card would both read as selected.
  const isActive = location?.pathname === '/ai'
    && parseGeneratingRunId(location?.search ?? '') == null

  const handleClick = useCallback(() => {
    clearModelSettings()
    // Compare the search string too, so coming back from /ai?run=<id> still navigates and
    // drops the parameter - otherwise the generating card stays selected instead of this one.
    if (`${location?.pathname ?? ''}${location?.search ?? ''}` !== '/ai') {
      navigate('/ai')
    }
    onNavigate('new')
  }, [navigate, location, onNavigate])

  return (
    <div
      className={classnames(
        'model-card',
        'model-card--action',
        'model-card--new',
        isActive && 'model-card--active'
      )}
      onClick={handleClick}
    >
      <div className="model-card__action">
        <Icon svgComponent={Add} size={iconSizeMedium} color="dark" notSpaced />
        <span className="model-card__action-text">
          {t('sidebar.newModelCard.titleLine1')}
          <br/>
          {t('sidebar.newModelCard.titleLine2')}
        </span>
      </div>
    </div>
  )
}

NewModelCard.propTypes = {
  onNavigate: func.isRequired,
}

export default memo(NewModelCard)
